export default __webpack_public_path__ + "static/media/Copy.f52d7bef.svg";